import { Layout } from 'react-admin';
import { MyMenu } from './myMenu';

const MyLayout = props => <Layout
    {...props}
    menu={MyMenu}
/>;

export default MyLayout;